export default "__VITE_ASSET__CwrH0ji8__"